import { Box, Chip, Typography } from "@mui/material"
import { forwardRef } from "react"
import type { ReactNode } from "react"

interface InventoryWorkOrderPrintLayoutProps {
  title: string
  chip: ReactNode
  workDate: string
  warehouseLabel: string
  children: ReactNode
}

export const InventoryWorkOrderPrintLayout = forwardRef<HTMLDivElement, InventoryWorkOrderPrintLayoutProps>(
  ({ title, chip, workDate, warehouseLabel, children }, ref) => (
    <Box
      ref={ref}
      sx={{
        display: "none",
        "@media print": {
          display: "block",
          position: "static",
          overflow: "visible",
          height: "auto",
          width: "100%",
        },
      }}
      className='p-6'
    >
      <Box className='mb-5 flex flex-col gap-y-4 rounded-md border border-gray-400 bg-white px-4 py-6'>
        <Box className='flex items-center gap-x-4'>
          <Typography variant='h5' className='text-gray-800'>
            {title}
          </Typography>
          {chip}
        </Box>
        <Typography variant='body2' className='flex items-center gap-x-2 text-gray-700'>
          Work Date:
          <Chip component='span' className='h-6 rounded text-xs' label={workDate}></Chip>
        </Typography>
        <Typography variant='body2' className='text-gray-700'>
          Warehouse Location: {warehouseLabel}
        </Typography>
      </Box>

      {children}
    </Box>
  )
)
